import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Divider,
  Grid,
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
  Table,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { MdCancel } from "react-icons/md";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { Formik, Form, Field } from "formik";
import { AiFillThunderbolt } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
// import "../../Pages/StakeNow/AddToCart/CartPageComponent/Modal/BannerinputGetModal.css";
import "../../ContentManagement/Home/Modal/BannerinputGetModal.css";

import { IoIosWarning } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions";
import { toast } from "react-toastify";
import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";

const WarningModal = ({
  open,
  onClose,
  setGrams,
  resetForm,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
  handleNextModal,
  editData,
  values,
  handleSchemeModaClose
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const TableId = useSelector((state) => state.Table.TableId);
  const { updatePlanPut } = useSelector((state) => state?.updatePlanPut);
  const { addPlanPost } = useSelector((state) => state?.addPlanPost);

  const { addPlanWithApproval } = useSelector((state) => state?.addPlanWithApproval);
  const { updatePlanForReApproval } = useSelector((state) => state?.updatePlanForReApproval);

  const role = sessionStorage.getItem("role")

  const handleModalConfirm = async () => {

    if (role === "superAdmin") {
      if (!editData?.payload?.data) {

        const data1 = {
          data: values,
          method: "post",
          apiName: "addPlanWithApproval",
        };

        const responseData = await dispatch(actions.ADDPLANWITHAPPROVAL(data1));

        if (responseData?.payload?.message === "Plan added and approved successfully..") {
          toast.success(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        } else {
          // toast.error(responseData?.payload?.message)
          toast.error(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        }
      } else {
        const data1 = {
          data: values,
          method: "put",
          apiName: `updatePlan/${TableId}`,
        };

        const responseData = await dispatch(actions.UPDATEPLANPUT(data1));

        if (responseData?.payload?.message === "Plan updated successfully.") {
          toast.success(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        } else {
          toast.error(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        }

      }
    } else {
      if (!editData?.payload?.data) {

        const data1 = {
          data: values,
          method: "post",
          apiName: "addPlan",
        };

        const responseData = await dispatch(actions.ADDPLANPOST(data1));

        if (responseData?.payload?.message === "Plan added successfully.") {
          toast.success(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })

        } else {
          toast.error(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        }
      } else {
        const data1 = {
          data: values,
          method: "put",
          apiName: `updatePlanForReApproval/${TableId}`,
        };

        const responseData = await dispatch(actions.UPDATEPLANFORREAPPROVAL(data1));

        if (responseData?.payload?.message === "Plan updated and sent for re-approval.") {
          toast.success(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        } else {
          toast.error(responseData?.payload?.message)
          setTimeout(() => {
            resetForm();
            setGrams();
            onClose()
            handleSchemeModaClose()
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

          })
        }

      }
    }
    // onClose();

  };
  return (
    <Dialog
      open={open}
      //   onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "500px",
          //   borderRadius: "2px",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                Purchase Document
              </Typography>
            </Box>
          </DialogTitle>
        </Box> */}

        <DialogContent
          dividers
          sx={{
            padding: 0,
            "& .MuiDialogContent-root": {
              padding: 0,
            },
            color: "#7A7A7A",
            p: { xs: 2, md: "16px 24px" },
          }}
        // sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <Grid
            item
            sx={{
              display: "flex",
              //   justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box>
              <IoIosWarning
                style={{
                  // color: "#eba30a",
                  color: "#C38F51",

                  fontSize: "25px",
                  marginRight: "5px",
                }}
              />
            </Box>
            <Typography
              variant="subtitle2"
              color="black"
              textAlign="center"
              sx={{ fontSize: "18px", fontWeight: "500" }}
            >
              Are you sure want to add?
            </Typography>
          </Grid>
          <Grid item>
            <Box sx={{ mt: 2, ml: 1 }}>
              <Typography>
                {/* Please upload required documents before register */}
                Please confirm if this scheme will be added to the plan, and if
                any additional changes are needed before proceeding
              </Typography>
            </Box>
          </Grid>

          <Grid xs={12} mt={2}>
            <Grid
              container
              justifyContent="end"
              alignItems="center"
              spacing={2} // Add spacing between buttons
            >
              <Grid item>
                <Button
                  onClick={() => {
                    onClose()
                  }}
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    color: "white",
                    fontSize: "14px",
                    padding: { xs: "0px 10px", md: "0px 20px" },
                    minHeight: "40px",
                    // borderRadius: "23px",
                    background: "#d5d3d3",
                    boxShadow: "none",
                    color: "black",
                    // border: "1px solid black",
                    // "&:hover": {
                    //   backgroundColor: "#3B4056",
                    //   color: "white",
                    // },
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => handleModalConfirm()}
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    color: "white",
                    fontSize: "14px",
                    boxShadow: "none",
                    padding: { xs: "0px 10px", md: "0px 20px" },
                    minHeight: "40px",
                    // borderRadius: "23px",
                    background: "#C38F51 0% 0% no-repeat padding-box",
                    // "&:hover": {
                    //   backgroundColor: "#3B4056",
                    //   boxShadow: "none",
                    // },
                  }}
                //   disabled={!values.privacyChecked} // Disable button if checkbox is not checked
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default WarningModal;
